import { NetworkItem } from "../../../../types/moj-elektro"

export const getDateKey = (formattedMonth: string): string => {
    const [monthStr, yearStr] = formattedMonth.split("-")
    const months: { [key: string]: number } = {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        oct: 10,
        nov: 11,
        dec: 12,
    }
    const monthNum = months[monthStr.toLowerCase()]
    const year = parseInt(yearStr, 10)

    const date = new Date(Date.UTC(year, monthNum - 1, 1, 0, 0, 0))

    const inDST = isDST(year, monthNum)

    const offsetHours = inDST ? 2 : 1
    const offsetSign = "+"
    const formattedOffset = offsetSign + String(offsetHours).padStart(2, "0") + ":00"

    const dateString =
        date.getUTCFullYear() +
        "-" +
        String(date.getUTCMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getUTCDate()).padStart(2, "0") +
        "T" +
        "00:00" +
        formattedOffset

    return dateString
}

function isDST(year: number, month: number): boolean {
    const dstStart = getLastSundayOfMonth(year, 3)
    const dstEnd = getLastSundayOfMonth(year, 10)

    const dstStartDate = new Date(Date.UTC(year, 2, dstStart, 1, 0, 0))
    const dstEndDate = new Date(Date.UTC(year, 9, dstEnd, 1, 0, 0))
    const currentDate = new Date(Date.UTC(year, month - 1, 1, 0, 0, 0))

    return currentDate >= dstStartDate && currentDate < dstEndDate
}

function getLastSundayOfMonth(year: number, month: number): number {
    const lastDay = new Date(Date.UTC(year, month, 0))
    const dayOfWeek = lastDay.getUTCDay()
    const lastSunday = lastDay.getUTCDate() - dayOfWeek

    return lastSunday
}

export function extractData(calculationData: Record<string, any>, dataKey: string): number[] {
    const data: number[] = []
    Object.values(calculationData).forEach((value) => {
        if (value[dataKey].amount) {
            data.unshift(value[dataKey].amount)
        }
    })

    return data
}

export const createEmptyRows = (count: number): NetworkItem[] => {
    return Array.from({ length: count }, () => ({
        category: "EMPTY",
        isEmpty: true,
        pricePerUnit: { amount: "", unit: "" },
        totalCost: { amount: "", unit: "" },
        value: { amount: "", unit: "" },
        occurrences: 0,
        excessivePower: { amount: "", unit: "" },
        excessivePowerCost: { amount: "", unit: "" },
    }))
}

export const adjustGroupDataToSixRows = (groupData: NetworkItem[]): NetworkItem[] => {
    const totalRows = 5
    const currentRows = groupData.length
    const emptyRowsNeeded = totalRows - currentRows
    const newGroupData = [...groupData]

    if (emptyRowsNeeded > 0) {
        const emptyRows = createEmptyRows(emptyRowsNeeded)

        newGroupData.splice(-1, 0, ...emptyRows)
    }

    return newGroupData
}

export const totalRowStyleClass = (row: any) => {
    if (row.isGrandTotal) {
        return "grand-total-row"
    }

    if (row.isEmpty) {
        return "empty-row"
    }

    return row.isTotal ? "total-row" : ""
}
